/**
 * A function that returns undefined.
 * It's used as a temporary solution for existing code that uses `undefined`.
 *
 * New code should use an `Option`.
 */
export default function noValue() {
  return undefined
}
